module.exports = __webpack_public_path__ + "static/media/styling-and-furnishing-2.1278d59f.png";